import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'debtor-panel-forbidden',
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.scss'],
})
export class ForbiddenComponent {
  private router = inject(Router);

  public navigateToHome(event: Event): void {
    event.preventDefault();
    this.router.navigate(['']);
  }
}
